import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import axios from 'axios';
import { environment } from '../../../../environments/environment';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-new-base',
  templateUrl: './new-base.component.html',
  styleUrls: ['./new-base.component.scss']
})
export class NewBaseComponent implements OnInit {
  token = window.sessionStorage.getItem('token');
  userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
  mode = 'Create';
  // define base object
  base = {
    active: true,
    deleted: false,
    id: '',
    affiliated: '',
    edit: false,
    functionArea: '',
    show: false
  };

  // define form sections
  sections = [
    {
      title: 'Base Information',
      data: [
        {
          input: true,
          required: true,
          placeholder: 'Name',
          key: 'name',
          maxlength: 30
        },
        {
          input: true,
          required: true,
          placeholder: 'Code',
          key: 'code',
          maxlength: 3
        },
        {
          input: true,
          type: 'checkbox',
          placeholder: 'Active',
          key: 'active'
        }
      ]
    }
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toast: ToastService
  ) {}

  ngOnInit(): void {
    // if we see an '/:id' instead of '/new' in the URL,
    // we are in "update" mode instead of "create" mode
    let url = window.location.href;
    let id = url.slice(url.lastIndexOf('/') + 1, url.length);
    if (id.includes(';')) {
      id = url.slice(url.lastIndexOf('/') + 1, url.indexOf(';'));
    }
    this.base.id = id;
    if (id !== 'new') {
      this.beginUpdateMode(id);
    }
  }

  beginUpdateMode = async (id) => {
    this.mode = 'Update';
    let base = await axios.get(environment.API_URL + '/base/' + id, {
      headers: { Authorization: 'Bearer ' + this.token }
    });
    this.base = base.data;
    this.base.active = !this.base.deleted;
    this.base.id = id;
  };

  submitForm = (data) => {
    let baseCode = this.userInfo.basecode;
    const options = {
      headers: { Authorization: 'Bearer ' + this.token }
    };
    let url = environment.API_URL + '/base/add';

    if (this.mode === 'Create') {
      delete this.base.id;
      this.base.affiliated = baseCode;
      this.base.edit = false;
      this.base.deleted = !this.base.active;
      axios
        .post(url, this.base, options)
        .then((response) => {
          // pop success toast and redirect to list
          this.toast.show('Created Base', 'success');
          this.router.navigate(['/bases']);
        })
        .catch((error) => {
          this.toast.show('Unable to Create Base', 'error');
          console.dir(error);
        });
    } else if (this.mode === 'Update') {
      this.base.deleted = !this.base.active;
      url = environment.API_URL + '/base/' + this.base.id + '/update';
      axios
        .post(url, this.base, options)
        .then((response) => {
          // pop success toast and redirect to list
          this.toast.show('Updated Base', 'success');
          this.router.navigate(['/bases']);
        })
        .catch((error) => {
          this.toast.show('Unable to Update Base', 'error');
          console.dir(error);
        });
    }
  };
}
